import { Component, Input } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-gradient-header',
  templateUrl: './gradient-header.component.html',
  styleUrls: ['./gradient-header.component.scss']
})
export class GradientHeaderComponent {
  @Input() isSticky = false;

  isScc = false;

  constructor(readonly appStateService: AppStateService) {
    this.isScc = appStateService.isScc;
  }

  public switchSticky() {
    this.isSticky = !this.isSticky;
  }
}
